














































import { Component, Prop, Emit, Vue } from "vue-property-decorator";
import InsuranceInfo from "@/models/InsuranceInfo";
import { ValidationProvider, extend } from "vee-validate";

extend("nonzero", {
  validate: value => {
    return value !== null && value > 0;
  },
  message: "Proszę podać wartość"
});

@Component({
  components: {
    ValidationProvider
  }
})
export default class SubmissionFormInsuranceInfo extends Vue {
  @Prop() private insuranceInfo!: InsuranceInfo;

  @Emit()
  insuredChange(e: Event) {
    return (e.target as HTMLSelectElement).value;
  }
}
